/* Shipping protection guard: shipping protection can't be bought on its own.
   Oct 20, 2026: the old version fetched /cart.js on EVERY page change (66+ requests
   in 8 seconds on the cart page), which queued the Check out click behind them.
   Same rule, now checked at most once per 600 ms, never two checks at once,
   its own message ignored, and it stops checking once the shopper clicks Check out. */
(function () {
  const WARRANTY_PRODUCT_TYPE = "Warranty";
  const MESSAGE_TEXT = "Shipping protection must be purchased with another item.";
  let timer = null, busy = false, again = false, leaving = false;

  function isCheckoutButton(el) {
    if (!el) return false;
    const isNameCheckout = el.name === "checkout";
    const isHrefCheckout = (el.getAttribute("href") || "").includes("/checkout");
    const isActionCheckout = (el.getAttribute("formaction") || "").includes("/checkout");
    const isCheckoutClass = (typeof el.className === "string" ? el.className : "").toLowerCase().includes("checkout");
    return isNameCheckout || isHrefCheckout || isActionCheckout || isCheckoutClass;
  }

  function findCheckoutButtons() {
    return Array.from(document.querySelectorAll("button, input[type='submit'], a")).filter(isCheckoutButton);
  }

  function ensureMessageNear(btn) {
    const existing = btn.parentElement && btn.parentElement.querySelector(".warranty-guard-message");
    if (existing) return existing;
    const msg = document.createElement("div");
    msg.className = "warranty-guard-message";
    msg.style.cssText = "margin-top:10px;padding:10px 12px;border:1px solid rgba(0,0,0,0.15);border-radius:8px;font-size:14px;line-height:1.3;display:none";
    msg.textContent = MESSAGE_TEXT;
    (btn.parentElement || document.body).appendChild(msg);
    return msg;
  }

  function setCheckoutDisabled(disabled) {
    findCheckoutButtons().forEach(function (btn) {
      const msg = disabled ? ensureMessageNear(btn) : (btn.parentElement && btn.parentElement.querySelector(".warranty-guard-message"));
      if (btn.tagName.toLowerCase() === "a") {
        if (disabled) {
          btn.setAttribute("aria-disabled", "true");
          if (btn.getAttribute("href")) btn.dataset.warrantyGuardHref = btn.getAttribute("href");
          btn.removeAttribute("href");
          btn.style.pointerEvents = "none";
          btn.style.opacity = "0.5";
        } else if (btn.dataset.warrantyGuardHref !== undefined) {
          btn.setAttribute("aria-disabled", "false");
          btn.setAttribute("href", btn.dataset.warrantyGuardHref);
          delete btn.dataset.warrantyGuardHref;
          btn.style.pointerEvents = "";
          btn.style.opacity = "";
        }
      } else if (disabled || btn.dataset.warrantyGuardOff) {
        btn.disabled = !!disabled;
        btn.style.opacity = disabled ? "0.5" : "";
        btn.style.cursor = disabled ? "not-allowed" : "";
        if (disabled) btn.dataset.warrantyGuardOff = "1"; else delete btn.dataset.warrantyGuardOff;
      }
      if (msg) msg.style.display = disabled ? "block" : "none";
    });
  }

  async function checkCartAndEnforce() {
    if (leaving) return;
    if (busy) { again = true; return; }
    busy = true;
    try {
      const res = await fetch("/cart.js", { credentials: "same-origin" });
      if (res.ok) {
        const items = (await res.json()).items || [];
        setCheckoutDisabled(items.length === 1 && (items[0].product_type || "") === WARRANTY_PRODUCT_TYPE);
      }
    } catch (e) {
      setCheckoutDisabled(false);
    } finally {
      busy = false;
      if (again) { again = false; schedule(); }
    }
  }

  function schedule() {
    if (leaving) return;
    clearTimeout(timer);
    timer = setTimeout(checkCartAndEnforce, 600);
  }

  function startWatching() {
    checkCartAndEnforce();
    document.addEventListener("cart:updated", schedule);
    document.addEventListener("cart:refresh", schedule);
    const observer = new MutationObserver(function (records) {
      for (const r of records) {
        const t = r.target;
        if (t && t.classList && t.classList.contains("warranty-guard-message")) continue;
        schedule();
        return;
      }
    });
    observer.observe(document.body || document.documentElement, { childList: true, subtree: true });
    window.addEventListener("focus", schedule);
    document.addEventListener("submit", function (e) {
      const s = e.submitter;
      if (s && isCheckoutButton(s)) { leaving = true; clearTimeout(timer); observer.disconnect(); }
    }, true);
    document.addEventListener("click", function (e) {
      const a = e.target && e.target.closest && e.target.closest("a");
      if (a && isCheckoutButton(a) && a.getAttribute("href")) { leaving = true; clearTimeout(timer); observer.disconnect(); }
    }, true);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", startWatching);
  else startWatching();
})();
